import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EMessageType } from './message';
import { EModel } from './model';
export let EHl7MessageType;
(function (EHl7MessageType) {
  EHl7MessageType["AdtA01"] = "ADT_A01";
  EHl7MessageType["AdtA02"] = "ADT_A02";
  EHl7MessageType["AdtA03"] = "ADT_A03";
  EHl7MessageType["AdtA04"] = "ADT_A04";
  EHl7MessageType["AdtA05"] = "ADT_A05";
  EHl7MessageType["AdtA08"] = "ADT_A08";
  EHl7MessageType["AdtA11"] = "ADT_A11";
  EHl7MessageType["AdtA12"] = "ADT_A12";
  EHl7MessageType["AdtA13"] = "ADT_A13";
  EHl7MessageType["AdtA38"] = "ADT_A38";
  EHl7MessageType["AdtA40"] = "ADT_A40";
  EHl7MessageType["AdtA44"] = "ADT_A44";
  EHl7MessageType["MdmT01"] = "MDM_T01";
  EHl7MessageType["MdmT02"] = "MDM_T02";
  EHl7MessageType["MdmT03"] = "MDM_T03";
  EHl7MessageType["MdmT04"] = "MDM_T04";
  EHl7MessageType["OrmO01"] = "ORM_O01";
  EHl7MessageType["OrmO02"] = "ORM_O02";
  EHl7MessageType["OrmR01"] = "ORU_R01";
  EHl7MessageType["SiuS12"] = "SIU_S12";
  EHl7MessageType["SiuS13"] = "SIU_S13";
  EHl7MessageType["SiuS14"] = "SIU_S14";
  EHl7MessageType["SiuS15"] = "SIU_S15";
  EHl7MessageType["SiuS16"] = "SIU_S16";
  EHl7MessageType["SiuS17"] = "SIU_S17";
  EHl7MessageType["SiuS18"] = "SIU_S18";
  EHl7MessageType["SiuS19"] = "SIU_S19";
  EHl7MessageType["SiuS20"] = "SIU_S20";
  EHl7MessageType["SiuS21"] = "SIU_S21";
  EHl7MessageType["SiuS22"] = "SIU_S22";
  EHl7MessageType["SiuS23"] = "SIU_S23";
  EHl7MessageType["SiuS24"] = "SIU_S24";
  EHl7MessageType["SiuS26"] = "SIU_S26";
})(EHl7MessageType || (EHl7MessageType = {}));
export let EHl7MessageIntegrator;
(function (EHl7MessageIntegrator) {
  EHl7MessageIntegrator["Mi7"] = "mi7";
  EHl7MessageIntegrator["Hl7"] = "hl7";
  EHl7MessageIntegrator["RawHl7"] = "raw-hl7";
  EHl7MessageIntegrator["Lyniate"] = "lyniate";
})(EHl7MessageIntegrator || (EHl7MessageIntegrator = {}));
export let EHl7MessageStatus; // the message ack is delayed by the EHR
(function (EHl7MessageStatus) {
  EHl7MessageStatus["Pending"] = "pending";
  EHl7MessageStatus["Processing"] = "processing";
  EHl7MessageStatus["Completed"] = "completed";
  EHl7MessageStatus["Failed"] = "failed";
  EHl7MessageStatus["Delayed"] = "delayed";
})(EHl7MessageStatus || (EHl7MessageStatus = {}));
export const fieldsHl7Message = _extends({}, fieldsIBaseModel, {
  content: {
    type: 'Unknown'
  },
  direction: {
    type: 'Option',
    values: EMessageType
  },
  error: {
    type: 'Text'
  },
  integrator: {
    type: 'Option',
    values: EHl7MessageIntegrator
  },
  integratorRef: {
    type: 'ID',
    ref: EModel.Integrator
  },
  status: {
    type: 'Option',
    values: EHl7MessageStatus
  },
  type: {
    type: 'Option',
    values: EHl7MessageType
  }
});